export const handleAPIError = (error) => {
  return {
    isError: true,
    error,
    message: extractErrorMessage(error),
  };
};

export function APIError(error) {
  this.error = error;
}

export function extractErrorMessage(error) {
  if (error?.response?.data?.message) {
    return error.response.data.message;
  } else if (error?.message) {
    return error.message;
  }
  return "Unknown error";
}
